import { render } from "./PowerupsV3.vue?vue&type=template&id=029f806b&scoped=true"
import script from "./PowerupsV3.vue?vue&type=script&lang=js"
export * from "./PowerupsV3.vue?vue&type=script&lang=js"

import "./PowerupsV3.vue?vue&type=style&index=0&id=029f806b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029f806b"]])

export default __exports__